import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { StoreDispatch, StoreState } from "../types";

export const useStoreSelector: TypedUseSelectorHook<StoreState> = useSelector;

export const useStoreDispatch: () => StoreDispatch = useDispatch;
